import Vue from 'vue'
import Vuex from 'vuex'
import { firestoreInit, authorization, db } from '../../config/firebase'
import logic from './modules/logic'
import firebase from 'firebase'
import '@firebase/firestore'
import router from '../router'


Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        isLoading: true,
        artwork: [],
        collections: [],
        user: {},
        activeNav: false,
        messages: [],
        activePatient: {
          active: true,
          payload: {}
        },
        options: {
          active: false,
          controls: false,
          collectionName: null,
          addCollection: false,
          saved: false
        },
        getArt: [],
        activeArtwork: {},
        profileData: {},
        profileLoading: false,
        activeArt: [],
        rightNavigation: false
    },
    getters: {
        user: state => state.user,
        messages: state => state.messages,
        isLoading: state => state.isLoading,
        loggedIn: state => 'uid' in state.user,
        activePatient: state => state.activePatient,
        activeNav: state => state.activeNav
    },
    mutations: {
        putUser(state, payload) {
            state.user = payload
            state.isLoading = false
        },
        logIn(state, payload) {
            firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
            .then(user => {
              alert(`You are logged in as ${user.user.email}`)
              router.push('timeline')
            },
            err => {
              alert(err.message)
            })
          payload.event.preventDefault()
        },
        
        logInGoogle() {
            // console.log('Google Login');
            const provider = new firebase.auth.GoogleAuthProvider();
            firebase.auth().signInWithPopup(provider).then(function(result) {
                // This gives you a Google Access Token.
                var token = result.credential.accessToken;
                // The signed-in user info.
                var user = result.user;
                window.history.go(-1);
               });
        },
        logOut() {
            firebase.auth().signOut()
            .then((data) => {
              window.location.href = '/'
            })
        },
        addActive(state){
          state.activeNav = !state.activeNav
        },
        options(state) {
          return {
            1: state.options.active = !state.options.active,
            2: state.options.collectionName = null,
            3: state.options.addCollection = false,
            4: state.options.saved = false
          }
        },
        addLike(state) {
          
          return state.user.uid === undefined
          ? window.location.href = '/register'
          : firestoreInit.collection('artwork').doc(state.getArt.id).update({ likes: firebase.firestore.FieldValue.arrayUnion(state.user.email) })

        },
        unlike(state) {
            firestoreInit.collection('artwork').doc(state.getArt.id).update({ likes: firebase.firestore.FieldValue.arrayRemove(state.user.email) })
        },
        // profileData(state) {
        //   firestoreInit.collection('users').doc(state.user.uid)
        //   console.log('profile data')
        // },
        addCollection(state) {

            if (state.user !== false) {

                const createdAt = new Date()
                const collection = {
                  createdAt: createdAt,
                  name: state.options.collectionName
                }
      
                const pushChanges = {
                  uid: state.user.uid,
                  [`collection.${state.options.collectionName}`]: {
                    name: state.options.collectionName,
                    createdAt: createdAt
                  }
                }
      
                const pushCreate = {
                  uid: state.user.uid,
                  collection: {
                    [`${state.options.collectionName}`]: {
                      name: state.options.collectionName,
                      createdAt: createdAt
                    }
                  }
                }
      
              firestoreInit.collection('collections').doc(state.user.uid).get()
                .then(data => {
                  if (data.exists) {
                    firestoreInit.collection('collections').doc(state.user.uid).update(pushChanges)
                  } else {
                    firestoreInit.collection('collections').doc(state.user.uid).set(pushCreate)
                  }
                })
              // this.collectionInput = ''
            //   this.addCollection = false
            return {
              1: state.options.addCollection = false,
              2: state.options.saved = true
            }
            }
          }
    },
    actions: {
        fetchCreds({commit}) {
            firebase.auth().onAuthStateChanged(function(user) {
                if(user) {
                    const { displayName, email, photoURL, uid } = user;
                    const cleanedUser = { displayName, email, photoURL, uid };
                    commit('putUser', cleanedUser);

                } else {
                    commit('putUser', {});
                }
            })
        },
        options(context) {
            context.commit('options')
        },
        addActive(context) {
          context.commit('addActive')
        },
        addLike(context) {
            context.commit('addLike')
        },
        unlike(context) {
            context.commit('unlike')
        },
        addCollection(context) {
            context.commit('addCollection')
        }
    }
});




// WEBPACK FOOTER //
// ./src/store/index.js